<template>
  <div class="app-container">
    <el-card class="box-card">
      <div class="filter-container">
        <el-form :model="query" ref="queryForm" :inline="true">
          <el-form-item label="问题内容：">
            <el-input v-model="query.questionContent" placeholder="请输入讲师名称" clearable size="small" />
          </el-form-item>
          <el-form-item label="状态：">
            <el-select v-model="query.state" placeholder="请选择" clearable size="small">
              <el-option label="启用" :value="1"></el-option>
              <el-option label="禁用" :value="0"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item>
            <el-button type="primary" @click="handleQuery" size="mini">搜索</el-button>
            <el-button type="info" @click="handleFilter" plain size="mini">重置</el-button>
          </el-form-item>
        </el-form>
      </div>
    </el-card>
    <el-card class="box-card mt10">
      <div class="btn-right-side mb10">
        <div class="btn-box">
          <el-dropdown @command="handleCommand">
            <el-button type="primary" size="mini">批量操作<i class="el-icon--right el-icon-arrow-down"></i></el-button>
            <el-dropdown-menu slot="dropdown">
              <el-dropdown-item :command="beforeHandleCommand(row,1)" v-hasPermi="['course:scene:state']">批量启用</el-dropdown-item>
              <el-dropdown-item :command="beforeHandleCommand(row,2)" v-hasPermi="['course:scene:state']">批量禁用</el-dropdown-item>
            </el-dropdown-menu>
          </el-dropdown>
          <el-button type="primary" size="mini" @click="handleCreate" icon="el-icon-plus" v-hasPermi="['course:scene:add']">新建问题</el-button>
          <!-- <el-button type="danger" size="mini" @click="handleDeleteBatch" plain>批量删除</el-button> -->
        </div>
      </div>
      <el-table v-loading="listLoading" :data="list" @selection-change="selectionChange" @sort-change="sortChange">
        <el-table-column type="selection" width="50" />
        <el-table-column label="问题内容" prop="questionContent" align="center" width="200" show-overflow-tooltip />
        <el-table-column label="图片" prop="imgUrl" align="center">
          <template slot-scope="{row}">
            <div v-if="row.imgUrl">
              <el-image v-for="(item,index) in  row.imgUrl.split(',')" :key="index" style="width: 50px; height: 50px" :src="item" :preview-src-list="[item]"></el-image>
            </div>

          </template>
        </el-table-column>
        <el-table-column label="创建时间" prop="createdTime" sortable="custom" align="center" width="200" />
        <el-table-column label="状态" prop="isEnable" align="center">
          <template slot-scope="{row}">
            <el-switch v-model="row.state" :active-value="1" :inactive-value="0" @change="changeSwitch(row)" v-hasPermi="['course:scene:state']"></el-switch>
            {{row.state?'启用':'禁用'}}
          </template>
        </el-table-column>
        <el-table-column label="修改时间" prop="operatedTime" sortable="custom" align="center" width="200" />
        <el-table-column label="操作人" prop="operatedBy" align="center" />
        <el-table-column label="操作" align="center" width="230" fixed="right">
          <template slot-scope="{row}">
            <el-button type="text" @click="handleUpdate(row)" v-hasPermi="['course:scene:edit']">编辑</el-button>
            <el-button type="text" @click="handleLog(row)">日志记录</el-button>
            <!-- <el-button type="text" @click="handleDeleteSingle(row)">删除</el-button> -->
          </template>
        </el-table-column>
      </el-table>
      <pagination v-show="total>0" :total="total" :pageNo.sync="query.pageNo" :pageSize.sync="query.pageSize" @pagination="doQueryList" />
    </el-card>
    <!-- 新建表单 -->
    <scene-add ref="sceneAdd" @created="doQueryList({})" :menuOptions="list" />
  </div>
</template>

<script>
import sceneAdd from './add'
import courseScenarioExerciseApi from '@/api/course/courseScenarioExercise'
import Pagination from '@/components/Pagination'

export default {
  components: {
    Pagination,
    sceneAdd
  },
  data() {
    return {
      list: [],
      total: 0,
      listLoading: true,
      query: {
        pageNo: 1,
        pageSize: 10,
        questionContent: undefined,
        state: undefined,
      },
      selectItems: [],
      activeName: '1'
    }
  },
  created() {
    this.doQueryList({ pageNo: 1 })
  },
  methods: {
    handleFilter() {
      this.query = {}
      this.doQueryList({ pageNo: 1, pageSize: 10 })
    },
    /**
     * 选择框变化
     */
    selectionChange(val) {
      this.selectItems = val
    },
    /**
     * 触发后端排序
     */
    sortChange({ prop, order }) {
      const sortKeyMap = {
        'createdTime': 'createdTimeSortSign',
        'operatedTime': 'operatedTimeSortSign'
      }
      for (var k in sortKeyMap) {
        const sortKey = sortKeyMap[k]
        if (k !== prop) {
          this.query[sortKey] = null
        } else {
          if (order === 'ascending') {
            this.query[sortKey] = 1
          } else {
            this.query[sortKey] = -1
          }
        }
      }
      this.doQueryList({})
    },
    /**
     * 触发搜索操作
     */
    handleQuery() {
      this.doQueryList({ pageNo: 1 })
    },
    /**
     * 执行列表查询
     */
    doQueryList({ pageNo, pageSize }) {
      if (pageNo) {
        this.query.pageNo = pageNo
      }
      if (pageSize) {
        this.query.pageSize = pageSize
      }
      this.listLoading = true
      return courseScenarioExerciseApi.fetchList(this.query)
        .then(data => {
          this.list = data.data.list
          this.total = data.data.total
        })
        .finally(() => {
          this.listLoading = false
        })
    },
    /**
     * 删除单条记录
     */
    handleDeleteSingle(row) {
      return this.$common.confirm('是否确认删除')
        .then(() => courseScenarioExerciseApi.deleteById(row.id))
        .then(() => {
          this.$common.showMsg('success', '删除成功')
          return this.doQueryList({ pageNo: 1 })
        })
    },
    /**
     * 批量删除记录
     */
    handleDeleteBatch() {
      if (this.selectItems.length <= 0) {
        this.$common.showMsg('warning', '请选择角色')
        return
      }
      return this.$common.confirm('是否确认删除')
        .then(() => courseScenarioExerciseApi.deleteBatch(this.selectItems.map(row => row.id)))
        .then(() => {
          this.$common.showMsg('success', '删除成功')
          return this.doQueryList({ pageNo: 1 })
        })
    },
    beforeHandleCommand(row, command) {
      return {
        'row': row,
        'command': command
      }
    },
    handleCommand(command) {
      if (this.selectItems.length <= 0) {
        this.$common.showMsg('warning', '请选择')
        return
      }
      let ids = this.selectItems.map(row => row.id)
      let txt = ""
      if (command.command === 1) {
        this.handleBatchState(ids, 1)
      } else if (command.command === 2) {
        this.handleBatchState(ids, 0)
      }
    },
    handleBatchState(ids, type) {
      let txt = type ? '是否确认批量启用？' : '是否确认批量禁用？'
      this.$common.confirm(txt).then(() => courseScenarioExerciseApi.setIsEnable({ exerciseIdList: ids.toString(), state: type }))
        .then(() => {
          this.$common.showMsg('success', '操作成功')
          return this.doQueryList({})
        })
    },
    changeSwitch(row) {
      courseScenarioExerciseApi.setIsEnable({ exerciseIdList: [row.id], state: row.state }).then(() => {
        this.$common.showMsg('success', '操作成功')
      })
    },
    /**
     * 打开新建表单
     */
    handleCreate(row) {
      this.$refs.sceneAdd.handleCreate(row)
    },
    /**
     * 打开查看表单
     */
    handleShow(row, type) {
      this.$emit('handleShow', row, type)
    },
    /**
     * 打开编辑表单
     */
    handleUpdate(row) {
      this.$refs.sceneAdd.handleUpdate(row)
    },
    handleLog(row) {
      this.$router.push("/log/log?type=5&id=" + row.id);
    }
  }
}
</script>
